import { Notificacion } from "@components/general/Alertas/Alertas";
import UserContext from "@context/User/UserContext";
import dashboardRoutesPaths from "@helpers/dashboardRoutesPaths/dashboardRoutesPaths";
import getPrecioFormateado from "@helpers/formateoPrecios/getPreciosFormateado";
import { createCheckoutSession, getPriceLiquidacion } from "@helpers/httpRequests/httpRequestsPagos/httpRequestsPagos";
import { validarDatosPago } from "@helpers/httpRequests/httpRequestsSAI/httpRequestsSAI";
import stripe from "@helpers/stripe/stripe";
import typesTiposUsuario from "@helpers/types/typesTiposUsuario";
import React, { useContext, useEffect, useState } from "react";
import { Button, Card, Col, Container, Row } from "react-bootstrap";
import Swal from "sweetalert2";

const LiquidacionAdeudo = () => {
	const { contextValue, setContextValue } = useContext(UserContext);

	const { usuarioLogeado } = contextValue;

	let { folioContrato, rol } = usuarioLogeado;

	if (rol === typesTiposUsuario.administrador) {
		folioContrato = "753";
	}

	const [montoPagado, setMontoPagado] = useState(0);

	const [costoTotalPagado, setCostoTotalPagado] = useState(true);

	useEffect(() => {
		const validarPago = async () => {
			try {
				const { data } = await validarDatosPago(folioContrato);

				const { pagado, costoTotal } = data;

				setMontoPagado(pagado);

				setCostoTotalPagado(pagado === costoTotal);
			} catch (error) {
				console.log(error);
			}
		};

		validarPago();
	}, []);

	const handleLiquidar = async () => {
		try {
			const { idPrecio } = await getPriceLiquidacion();

			const sessionData = {
				success_url: `${window.location.origin}${dashboardRoutesPaths.pagos.liquidacionRealizadaLoggedIn}`,
				cancel_url: `${window.location.origin}${dashboardRoutesPaths.dashboard}`,
				line_items: [{ price: idPrecio, quantity: 1 }],
				mode: "payment",
				currency: "mxn",
				metadata: {
					folioContrato,
				},
			};

			const checkoutSession = await createCheckoutSession(sessionData);

			const { isConfirmed } = await Swal.fire({
				title: "Saliendo de Click+",
				text: "Estás a punto de ser redirigido al sitio de pago",
				showCancelButton: true,
				reverseButtons: true,
				confirmButtonText: "Entendido",
				cancelButtonText: "Cancelar",
				confirmButtonColor: "#0d6efd",
				allowOutsideClick: false,
			});

			if (!isConfirmed) {
				return Notificacion("info", "La liquidación fue cancelada");
			}

			setContextValue({
				...contextValue,
				stripeSession: checkoutSession,
			});

			await (await stripe).redirectToCheckout({ sessionId: checkoutSession.id });
		} catch (error) {
			console.log("Error al intentar liquidar el adeudo: ", error);
		}
	};

	return (
		<Container fluid className="mt-4">
			<Row className="mb-4">
				<Col>
					<Card style={{ background: "#f8f9fa" }} className="shadow">
						<Container fluid>
							<Row className="mb-4">
								<Col>
									<h3 className="mb-3">Tu suscripción</h3>

									<p>
										<b>Folio de contrato:</b> {folioContrato}
									</p>

									<p>
										<b>Total pagado a la fecha:</b> ${getPrecioFormateado(montoPagado)}
									</p>

									{costoTotalPagado ? (
										<p>
											<b>Tu Licencia Click+ ha sido pagada en su totalidad</b>
										</p>
									) : (
										<>
											<p>
												<h5>
													Para saber el monto a pagar para realizar tu liquidación comunícate al <b>(477) 390-83-01 ext. 104</b> para conocer tu saldo.
												</h5>
											</p>

											<Button variant="success" onClick={handleLiquidar}>
												Liquidar ahora
											</Button>
										</>
									)}
								</Col>
							</Row>
						</Container>
					</Card>
				</Col>
			</Row>
		</Container>
	);
};

export default LiquidacionAdeudo;
